var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"printables-container"}},[_c('victim_letter_print',{ref:"victim_letter",attrs:{"vic_ltr_data":_vm.vic_ltr_data}}),_c('suspect_letter_print',{ref:"suspect_letter",attrs:{"sus_ltr_data":_vm.sus_ltr_data}}),_c('envelope_print',{ref:"envelope",attrs:{"envelope_data":_vm.envelope_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }